import { logger } from '@/utils/logger';
declare global {
    interface Window {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Kakao: any;
    }
  }
  
/**
 * Kakao SDK 초기화
 * SDK 스크립트 로드 완료를 대기한 후 초기화
 */
export const initKakao = (): Promise<boolean> => {
  return new Promise((resolve) => {
    // 이미 로드되고 초기화된 경우
    if (window.Kakao?.isInitialized?.()) {
      resolve(true);
      return;
    }

    // 이미 로드되었지만 초기화 안 된 경우
    if (window.Kakao) {
      window.Kakao.init(import.meta.env.VITE_KAKAO_JAVASCRIPT_KEY);
      resolve(true);
      return;
    }

    // SDK 로드 대기 (최대 10초)
    const maxWaitTime = 10000;
    const checkInterval = 100;
    let elapsedTime = 0;

    const checkKakaoLoaded = setInterval(() => {
      elapsedTime += checkInterval;

      if (window.Kakao) {
        clearInterval(checkKakaoLoaded);
        if (!window.Kakao.isInitialized()) {
          window.Kakao.init(import.meta.env.VITE_KAKAO_JAVASCRIPT_KEY);
        }
        resolve(true);
        return;
      }

      if (elapsedTime >= maxWaitTime) {
        clearInterval(checkKakaoLoaded);
        logger.error('Kakao SDK load timeout');
        resolve(false);
      }
    }, checkInterval);
  });
};

  export const unlinkKakaoAccount = async (): Promise<{ success: boolean; error?: string }> => {
    return new Promise((resolve) => {
      if (!window.Kakao.Auth.getAccessToken()) {
        resolve({ success: false, error: '카카오 로그인 상태가 아닙니다.' });
        return;
      }
   
      window.Kakao.API.request({
        url: '/v1/user/unlink',
        success: () => {
          resolve({ success: true });
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        fail: (error: any) => {
          logger.error('카카오 계정 연결 해제 실패:', error);
          resolve({ success: false, error: error.msg || '연결 해제 실패' });
        }
      });
    });
   };